import { format } from 'date-fns';

const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const WEEK = 7 * DAY;
const MONTH = 30 * DAY;

export const formatNotificationTime = (iso) => {
  if (!iso) { return ''; }
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) { return ''; }

  const diff = Date.now() - date.getTime();
  if (diff < MINUTE) { return 'just now'; }
  if (diff < HOUR) { return `${Math.floor(diff / MINUTE)}m ago`; }
  if (diff < DAY) { return `${Math.floor(diff / HOUR)}h ago`; }
  if (diff < WEEK) { return `${Math.floor(diff / DAY)}d ago`; }
  if (diff < MONTH) { return `${Math.floor(diff / WEEK)}w ago`; }
  return format(date, 'dd MMM, yyyy');
};
